// Constantes de marca compartilhadas. Vive fora de App.js/PanelApp.js para que
// o chunk do iframe não precise importar o painel (ver App.js).
export const config = {
  companyName: "InfinitAgents",
  logoUrl: null
};
